import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from '@openng/ngx-toastr';
import { ContributorCommissionRatePlanService } from '../../../services/contributor-commission-rate-plan.service';
import { ContributionIncentiveProgramService } from '../../../services/contribution-incentive-program.service';
import { FixedBurdenPlanService } from '../../../services/fixed-burden-plan.service';
import { PermanentPlanService } from '../../../services/permanent-plan.service';
import { RolesService } from '../../../services/roles.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-dialog-delete',
  imports: [MatButtonModule],
  templateUrl: './dialog-delete.component.html',
  styleUrl: './dialog-delete.component.scss'
})
export class DialogDeleteComponent {
  constructor(
    private dialogRef: MatDialogRef<DialogDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commissionRatePlanService: ContributorCommissionRatePlanService,
    private incentiveProgramService: ContributionIncentiveProgramService,
    private fixedBurdenPlanService: FixedBurdenPlanService,
    private permanentPlanService: PermanentPlanService,
    private commonService: CommonService,
    private roleService: RolesService,
    private toasterService: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  delete(): void {

    const action = this.data.action;
    const id = this.data.formData?.id || this.data.id;
    switch (action) {
      case 'commissionRatePlan':
        this.commissionRatePlanService.deleteCommissionRatePlan(id).subscribe({
          next: () => {
            this.toasterService.success('Commission Rate Plan submitted for approval successfully');

            this.dialogRef.close();
          },
          error: (error) => {

            this.commonService.handleError(error);
          }
        });
        break;
      case 'incentiveProgram':
        this.incentiveProgramService.deleteIncentiveProgram(id).subscribe({
          next: () => {
            this.toasterService.success('Incentive Program deleted successfully');

            this.dialogRef.close();
          },
          error: (error) => {

            this.commonService.handleError(error);
          }
        });
        break;
      case 'fixedBurdenPlan':
        this.fixedBurdenPlanService.deleteFixedBurdenPlan(id).subscribe({
          next: () => {
            this.toasterService.success('Fixed Burden Rate Plan submitted for approval successfully');

            this.dialogRef.close();
          },
          error: (error) => {

            this.commonService.handleError(error);
          }
        });
        break;
      case 'permanentPlan':
        this.permanentPlanService.deletePermanentPlan(id).subscribe({
          next: () => {
            this.toasterService.success('Permanent Plan submitted for approval successfully');

            this.dialogRef.close();
          },
          error: (error) => {

            this.commonService.handleError(error);
          }
        });
        break;
      case 'role':
        this.roleService.deleteRole(id).subscribe({
          next: () => {
            this.toasterService.success('Role delete submitted for approval successfully');

            this.dialogRef.close();
          },
          error: (error) => {

            this.commonService.handleError(error);
          }
        });
        break;
      default:

        this.toasterService.error('Unknown delete action', 'Error');
        break;
    }
  }
}
